import UserChatBubbleFloatingMenus from './UserChatBubbleFloatingMenus'
import UserChatBubbleFloatingPopper from './UserChatBubbleFloatingPopper'
import UserChatBubbleHoverAnchor from './UserChatBubbleHoverAnchor'

export default function UserChatBubbleHideActionsBranch(props) {
  return (
    <>
      <UserChatBubbleHoverAnchor {...props} />
      <UserChatBubbleFloatingPopper {...props} />
      <UserChatBubbleFloatingMenus {...props} />
    </>
  )
}
